import { safePost } from '@mo/mo-safe-request';
import { ServiceUnavailableError } from '../../common/errors';
import { apiUrl } from '../../common/gateway';
import { GENERIC_PING_PASSWORD_ERROR, PasswordValidationErrors } from '../../common/passwordValidation/errors';

export async function resetPassword(username: string): Promise<unknown> {
    return safePost(apiUrl(`password/forgotPassword`, 'v1'), { username }).catch(() => {
        throw new ServiceUnavailableError();
    });
}

export async function verifyToken(token?: string): Promise<unknown> {
    return safePost(apiUrl(`password/verifyToken`, 'v1'), { token }).catch(() => {
        throw new ServiceUnavailableError();
    });
}

export async function verifyPasswordResetToken(token: string, username: string): Promise<unknown> {
    return safePost(apiUrl(`password/verifyPasswordResetToken`, 'v1'), { token, username }).catch(() => {
        throw new ServiceUnavailableError();
    });
}

export async function updatePassword(password: string, username: string): Promise<unknown> {
    return await throwingChangePasswordErrors(
        (): Promise<unknown> => safePost(apiUrl(`password/updatePassword`, 'v1'), { password, username })
    );
}

export async function throwingChangePasswordErrors(fn: () => Promise<unknown>): Promise<void> {
    try {
        await fn();
    } catch (error: any) {
        if (error.response.status === 400) {
            throw new PasswordValidationErrors('Password validation error', [GENERIC_PING_PASSWORD_ERROR]);
        }
        throw new ServiceUnavailableError();
    }
}
